/* eslint-disable import/no-webpack-loader-syntax */
import { useEffect, useRef } from "react";
import { render } from "react-dom";
import mapboxgl from "!mapbox-gl";
import { useTranslation } from "react-i18next";
import Button from "../../../Common/FormElements/Button/Button";
import DeleteButton from "../../../Common/ListHeaderButtons/DeleteButton";

const LocationPopup = ({ map, activeFeature, onClose, handleDelete }) => {
  const popupRef = useRef();
  const contentRef = useRef(document.createElement("div"));

  useEffect(() => {
    if (!map) return;

    popupRef.current = new mapboxgl.Popup({
      closeOnClick: false,
      closeButton: false,
      offset: 20,
    });

    render(
      <div className="portal-content f16 quickSand">
        <DeleteButton styles="px-2" callback={handleDelete} />
      </div>,
      contentRef.current
    );

    return () => {
      popupRef.current.remove();
    };
  }, [map, activeFeature]);

  useEffect(() => {
    if (!activeFeature) {
      popupRef?.current?.remove();
      return;
    }

    popupRef.current
      .setLngLat(activeFeature)
      .setDOMContent(contentRef.current)
      .addTo(map);
  }, [activeFeature]);

  return null;
};

export default LocationPopup;
